/**
 * Returns key count/length
 */
export const objectLength = (obj: object) => {
	try {
		const length = Object.keys(obj).length
		return length
	} catch (err) {
		return 0
	}
}
